import { useContext } from "react";

import { ProjectContext } from "../../ProjectContext";

interface UseOverviewTabWithPreAccessReturnData {
  isPreAccess: boolean;
}

export const useOverviewTabWithPreAccess = (): UseOverviewTabWithPreAccessReturnData => {
  const { isPreAccess } = useContext(ProjectContext);

  return { isPreAccess };
};
